import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-navigator',
  templateUrl: './navigator.component.html',
  styleUrls: ['./navigator.component.scss']
})

export class NavigatorComponent implements OnInit {
  public showMenu: boolean = false;
  public header: string;
  public header_side_icon = "../../../assets/menu.svg";
    constructor(public commonService: CommonService) { }

    ngOnInit() {
        this.commonService.currentHeader.subscribe(header => this.header = header)
        this.commonService.currentHeaderLeftIcon.subscribe(header_side_icon => this.header_side_icon = header_side_icon)
    }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }
}
